// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"d73920fd","256":"e737064f","329":"3189175e","535":"75f3b777","888":"896391b3","922":"9a9f1233","991":"5ceaa516"}[chunkId] + ".chunk.js";
};